// Libraries
import React from 'react';

// Components
import { CardBlock, CardText } from 'Components/flowChart/components/NodePreview/components/styled';

// Types
import { BO_LABEL } from 'Components/flowChart/components/NodePreview/components/NodeUpdateSegment/constants';
import { IMetadata } from 'Components/flowChart/components/NodePreview/components/NodeUpdateSegment/types';
import { INodePreviewProps } from 'Components/flowChart/components/NodePreview/types';

const PATH = 'components/components/flowChart/components/Card/components/NodeWaitEvent/index.tsx';

export interface INodeUpdateSegment extends INodePreviewProps<IMetadata> {}

const NodeUpdateSegment: React.FC<INodeUpdateSegment> = (props) => {
	try {
		const {
			node: { metadata },
		} = props;
		const { itemTypeId, segmentIds } = metadata;

		return (
			<CardBlock>
				<CardText>{`Added audiences to ${segmentIds.length} ${BO_LABEL[itemTypeId]} segment(s)`}</CardText>
			</CardBlock>
		);
	} catch (e) {
		props.onError?.(e, {
			component: PATH,
			action: 'render -> NodeUpdateSegment',
			args: { props },
		});

		return null;
	}
};

export default NodeUpdateSegment;
